import api from './api';
import {
  CreateVisitasRapidaDto,
  PagedResult,
  UpdateVisitasEstadoDto,
  VisitasDto,
  VisitasHistorialDto,
  VisitasSearchDto,
} from '../types/visitas';

const visitasService = {
  getVisitas: async (params: VisitasSearchDto): Promise<PagedResult<VisitasDto>> => {
    const response = await api.get<PagedResult<VisitasDto>>('/api/Visitas', { params });
    return response.data;
  },

  getVisita: async (id: number): Promise<VisitasDto> => {
    const response = await api.get<VisitasDto>(`/api/Visitas/${id}`);
    return response.data;
  },

  createVisitaRapida: async (payload: CreateVisitasRapidaDto): Promise<VisitasDto> => {
    const response = await api.post<VisitasDto>('/api/Visitas/rapida', payload);
    return response.data;
  },

  iniciar: async (id: number, payload?: UpdateVisitasEstadoDto): Promise<VisitasDto> => {
    const response = await api.post<VisitasDto>(`/api/Visitas/${id}/iniciar`, payload ?? {});
    return response.data;
  },

  completar: async (id: number, payload?: UpdateVisitasEstadoDto): Promise<VisitasDto> => {
    const response = await api.post<VisitasDto>(`/api/Visitas/${id}/completar`, payload ?? {});
    return response.data;
  },

  omitir: async (id: number, payload?: UpdateVisitasEstadoDto): Promise<VisitasDto> => {
    const response = await api.post<VisitasDto>(`/api/Visitas/${id}/omitir`, payload ?? {});
    return response.data;
  },

  getHistorial: async (id: number): Promise<VisitasHistorialDto[]> => {
    const response = await api.get<VisitasHistorialDto[]>(`/api/Visitas/${id}/historial`);
    return response.data;
  },
};

export default visitasService;
